import React from 'react';
import "../../assets/Style.css"

import footerLogo from '../../assets/images/footer-logo.png';
import facebookIcon from '../../assets/images/footer-facebook.png';
import twitterIcon from '../../assets/images/footer-twitter.png';
import instagramIcon from '../../assets/images/footer-instagram.png';
import linkedinIcon from '../../assets/images/footer-linked.png';
import upworkIcon from '../../assets/images/footer-upwork.png';
import clutchIcon from '../../assets/images/footer-clutch.png';
import teamsIcon from '../../assets/images/footer-teams.png';
import { Link , NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <section className="footer-area">
        <div className="footer-links-icons">
          <div className="footer-logo">
            <Link to="/">
              <img src={footerLogo} alt="Code Buddy's Footer Logo" />
            </Link>

            <h6>Follow Us:</h6>
            <div className="social-a">
              <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/code.buddys">
                <img src={facebookIcon} alt="Facebook" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/Codebuddys">
                <img src={twitterIcon} alt="Twitter" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/code_buddys/">
                <img src={instagramIcon} alt="Instagram" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/code-buddy-s/">
                <img src={linkedinIcon} alt="LinkedIn" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.upwork.com/freelancers/~01db9a28dfd468e8e9?mp_source=share"
              >
                <img src={upworkIcon} alt="Upwork" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://clutch.co/profile/code-buddys">
                <img src={clutchIcon} alt="Clutch" />
              </a>
            </div>
          </div>

          <div className="links-box">
            <div className="footer-links">
              <h6>Menu</h6>
              <ul>
                <li><NavLink  to="/About">About Us</NavLink ></li>
                <li><NavLink  to="/Contact">Contact Us</NavLink ></li>
                <li><NavLink  to="/Service">Services</NavLink ></li>
              </ul>
            </div>
            <div className="footer-links">
              <h6>Service</h6>
              <ul>
                <li><Link to="/Service">Web Development</Link></li>
                <li><Link to="/Service">App Development</Link></li>
                <li><Link to="/Service">Designing</Link></li>
                <li><Link to="/Service">Digital Marketing</Link></li>
              </ul>
            </div>
          </div>

          <div className="social-links">
            <div className="address-li">
              <h6>Reach Us</h6>
              <p>B-608,  Rk Iconic, Near Shital Park, 150 Feet Ring Road, Rajkot-360006.</p>
              <p>345 King St N, Waterloo, ON N2J 2Z1.</p>
              <a href="tel:919737252452" className="telto">+919737252452</a>
              <a href="mailto:info@codebuddys.in" className="mailto">info@codebuddys.in</a>
              <a href="https://teams.microsoft.com/l/chat/0/0?users=doshiabhi420@gmail.com">
                <img src={teamsIcon} alt="Skype" className="teams" /> Code Buddy's
              </a>
            </div>
          </div>
        </div>

        <div className="copyright-bottom">
          <p className="copy-p">Copyright © 2025-26 Code Buddy's | All Rights Reserved</p>
          <div className="policy-terms">
            <li><NavLink  to="/PrivacyPolicy">Privacy Policy</NavLink ></li>
           <li><NavLink  to="/TermsofUse">Terms of Use</NavLink ></li>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
